import RelationNames from '@/constants/constituents/RelationNames';

const EditableRelations = [
  RelationNames.EMPLOYERS,
  RelationNames.EMPLOYEES,
  RelationNames.HOUSEHOLD,
];

export default EditableRelations;
